import styled from "styled-components";
import dottedImg from "assets/images/dottedBgHero.svg";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  margin: auto;
  @media (max-width: 1024px) {
    padding: 0;
    justify-content: center;
  }
`;

export const LoginContainer = styled.div`
  height: 100vh;
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: #ffffff;
  @media (max-width: 1024px) {
    background: none;
    flex-direction: column-reverse;
    align-items: center;
    height: auto;
    margin-top: 100px;
  }
`;
export const LogoContainer = styled.div`
  background: url(${dottedImg}) no-repeat top right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 62px;
  height: 65px;
  & > div {
    display: flex;
    align-items: center;
    margin-right: 290px;
  }
  h2 {
    font-size: 32px;
    color: ${(props) => props.color};
    font-weight: 700;
    margin-right: 10px;
  }
  @media (max-width: 1024px) {
    text-align: center;
    background: none;
    padding: 0;
    & > div {
      margin: auto auto;
    }
  }
`;

export const LoginFormcontainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: max-content;
  margin: auto 0 auto 325px;
  & .captcha {
    width: 100%;
  }
  & .re-captcha {
    margin-bottom: 20px;
    @media (max-width: 1024px) {
      margin: 20px 0;
    }
  }

  & form label {
    display: none;
    @media (max-width: 1024px) {
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: var(--text-500);
      font-family: "IRANYekanMobileFN";
      margin-bottom: 4px;
    }
  }
  & .button-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    & button {
      font-size: 16px;
      font-weight: 700;
      @media (max-width: 1024px) {
        font-size: 14px;
      }
    }
  }
  @media (max-width: 1440px) {
    margin-left: 100px;
  }
  @media (max-width: 1200px) {
    margin-left: 10px;
  }
  @media (max-width: 1070px) {
    margin-left: 0px;
  }
  @media (max-width: 1024px) {
    padding: 0;
    width: 100%;
    /* margin-bottom: 60px; */
    form {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      & > div {
        width: 100%;
        & > div:last-child {
          width: unset;
        }
      }
    }
  }
`;
export const HeaderLogin = styled.h1`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 51px;
  color: var(--text-500);
  margin-bottom: 45px;
  @media (max-width: 1024px) {
    text-align: center;
    font-weight: 800;
    font-size: 20px;
  }
`;

export const RememberPass = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
  color: #27548c;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  @media (max-width: 1024px) {
    width: calc(1024px - 32px);
  }
`;

export const Spreator = styled.hr`
  width: 404px;
  height: 1px;
  color: ${(props) => props.color || "#27548c"};
  background-color: ${(props) => props.color || "#27548c"};
  opacity: 0.4;
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const SignUpInvitation = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
  margin-top: 16px;
  direction: rtl;
  display: flex;
  align-items: center;
  justify-content: center;
  & span {
    color: var(--text-400);
    display: inline-flex;
    font-weight: 500;
    font-size: 14px;
  }
  & a {
    color: var(--text-500);
    font-weight: 500;
    font-size: 14px;
  }
  @media (max-width: 1024px) {
    width: 100%;
    margin-top: 26px;
    & span {
      color: var(--text-100);
      font-weight: 500;
      font-size: 14px;
    }

    & a {
      color: var(--primary-600);
      font-weight: 700;
      margin-right: 4px;
    }
  }
`;
